/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscriptionalertpurchaseunavailableappbanned5Inputs */



/**
* | output |
* | --- |
* | "Purchases in this app are unavailable in RuStore right now. Please try again a bit later." |
*
* @param {Subscriptionalertpurchaseunavailableappbanned5Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const subscriptionalertpurchaseunavailableappbanned5 = /** @type {((inputs?: Subscriptionalertpurchaseunavailableappbanned5Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscriptionalertpurchaseunavailableappbanned5Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Purchases in this app are unavailable in RuStore right now. Please try again a bit later.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Las compras en esta app no están disponibles en RuStore ahora. Inténtalo de nuevo un poco más tarde.")
	return /** @type {LocalizedString} */ ("Покупки в этом приложении сейчас недоступны в RuStore. Попробуйте ещё раз чуть позже.")
});
export { subscriptionalertpurchaseunavailableappbanned5 as "subscriptionAlertPurchaseUnavailableAppBanned" }